/* W11 — Export intégral par System (droit de sortie). Télécharge un JSON complet. */
import { useState } from "react";
import { api } from "@/lib/api";
import { notify, fmtError } from "@/lib/notify";
import { Download, Loader2 } from "lucide-react";

export function ExportButton({ system, label }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/workspace/export/${system}`);
      const blob = new Blob([JSON.stringify(r.data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `noam-export-${system}-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(url);
      notify.success("Export complet téléchargé — vos données vous appartiennent.");
    } catch (e) { notify.error(fmtError(e)); }
    setBusy(false);
  };
  return (
    <button onClick={download} disabled={busy} className="btn-ghost text-[10px] border border-white/10"
      title="Export intégral JSON — aucune rétention de données" data-testid={`export-btn-${system}`}>
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />} {label || "Exporter mes données"}
    </button>
  );
}
